import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';
import { WidgetTypes } from './dashboard-widget-model';

interface Props {
  icon: string;
  title: string;
  subtitle: string;
  type: WidgetTypes;
  isSelected: boolean;
  onClick: (type: WidgetTypes) => void;
}
export const ThumbnailWidgetCard = ({ icon, title, subtitle, type, isSelected, onClick }: Props) => {
  const { theme } = useCampfireTheme();
  return (
    <Box
      style={{
        background: theme.color.white.neutral50,
        border: isSelected ? '2px solid #b8b8b8' : '2px solid #DCDCDC',
        borderRadius: '6px',
        width: '180px',
        height: '200px',
        padding: '16px',
        cursor: 'pointer',
      }}
      onClick={() => onClick(type)}
    >
      <Box position={'absolute'}>
        {isSelected ? (
          <CheckCircle style={{ marginRight: '1rem', borderRadius: 15 }} color='primary' />
        ) : (
          <RadioButtonUnchecked style={{ marginRight: '1rem', borderRadius: 15 }} color='disabled' />
        )}
      </Box>
      <Box display='flex' justifyContent='center' my={4}>
        <img src={icon} alt='' style={{ height: '48px' }} />
      </Box>
      <Box display='flex' justifyContent='center' my={1}>
        <Typography
          style={{ fontWeight: 550, fontSize: '17px', lineHeight: '20px', color: theme.color.grey.neutral300 }}
        >
          {title}
        </Typography>
      </Box>
      <Box display='flex' justifyContent='center'>
        <Typography
          style={{ fontSize: '14px', lineHeight: '20px', color: theme.color.grey.neutral300, textAlign: 'center' }}
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};
